(function () {
    'use strict';

    angular
        .module('directives.oddMaxLength', [])
        .directive('oddMaxLength', directive);

    function directive() {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ngModelCtrl) {
                // Must pass a valid string containing a number
                if (typeof attrs.oddMaxLength !== 'string' || attrs.oddMaxLength.length === 0) return;

                var maxLength = Number(attrs.oddMaxLength);

                function oddMaxLengthParser(text) {
                    if (text && text.length > 0) {
                        ngModelCtrl.$setValidity('maxLength', maxLength < 0 || text.length <= maxLength);
                    }
                    return text;
                }
                if (maxLength !== 0) {
                    ngModelCtrl.$parsers.push(oddMaxLengthParser);
                    ngModelCtrl.$formatters.push(oddMaxLengthParser);
                }
            }
        }
    }
})();